import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
    @Input() heading: string;
    @Input() icon: string;
    @Input() currentView:String;

    @Output() switchView = new EventEmitter();

    constructor() {}

    ngOnInit() {}

    switchTo(view) {
        this.switchView.emit(view);
    }
}
